import { Box, Grid } from "@mui/material";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import InputFileUpload from "../../../../components/FileUploadButton";
import { RFHTextField } from "../../../../components/RFH";

function 
Form({ name, file, handleNameChange, handleFileChange, isMobile, className='' }) {
  const { register, watch, getValues, formState, ...methods } = useForm();
  const { errors } = formState;

  const onFormSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <FormProvider {...methods}>
      {file?.map((file, index) => (
        <div key={`board-attachments-${index}`} className={`${className} attachments-form-container`}>
          <Box
            component="form"
            noValidate
            className="d-flex attachment-form-box justify-content-space-between"
            onSubmit={(e) => onFormSubmit(e)}
            sx={{
              padding: isMobile ? "0px" : "8px",
            }}
          >
            <Grid
              container
              item
              xs={12}
              className="remove-container-width"
              justifyContent={"center"}
              alignItems={"center"}
              columnSpacing={2}
            >
              <Grid
                item
                xs={isMobile ? 12 : 5}
                md={isMobile ? 12 : 6}
                className="pl-0"
              >
                <RFHTextField
                  name={"name"}
                  placeholder="Name"
                  fullWidth={isMobile ? true : false}
                  value={name[index]?.name || ""}
                  className={`attachment-name-field ${isMobile && "mb-2"}`}
                  onChange={(e) => handleNameChange(e, index)}
                />
              </Grid>
              <Grid
                item
                xs={isMobile ? 12 : 5}
                md={isMobile ? 12 : 6}
                className={isMobile ? "padding-left-0 mobile-attach-file-upload-container" : ""}
              >
                <InputFileUpload
                  fileName={file?.name}
                  watch={watch}
                  register={register}
                  getValues={getValues}
                  fileChange={(e) => handleFileChange(e, index)}
                  isMobile={isMobile}
                  className={'upload-file'}
                />
              </Grid>
            </Grid>
          </Box>
        </div>
      ))}
    </FormProvider>
  );
}

export default Form;
